import { render, staticRenderFns } from "./e-new-version-informer.vue?vue&type=template&id=180cf0a8&scoped=true&lang=pug&"
import script from "./e-new-version-informer.vue?vue&type=script&lang=js&"
export * from "./e-new-version-informer.vue?vue&type=script&lang=js&"
import style0 from "./e-new-version-informer.vue?vue&type=style&index=0&id=180cf0a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180cf0a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
